<sm-spinner [loading]="loading$"></sm-spinner>
<div class="pt-4">
  <sm-form-builder [formObject]="formObject"></sm-form-builder>
</div>
